var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "m-shifts" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "shifts-modal",
            size: "custom-size",
            centered: "",
            "hide-footer": "",
          },
          on: {
            close: function ($event) {
              _vm.active = false
            },
          },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [_vm._v(" Показывать в таблице должности: ")]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.active,
            callback: function ($$v) {
              _vm.active = $$v
            },
            expression: "active",
          },
        },
        [
          _c("shadow-scroll-container", { staticClass: "scroll" }, [
            _c(
              "div",
              [
                _c("c-input", {
                  staticClass: "search",
                  attrs: {
                    placeholder: "Поиск по должности",
                    type: "text",
                    clearable: true,
                    icon: "search",
                  },
                  model: {
                    value: _vm.query,
                    callback: function ($$v) {
                      _vm.query = $$v
                    },
                    expression: "query",
                  },
                }),
              ],
              1
            ),
            !_vm.filteredList.length
              ? _c("div", { staticClass: "empty" }, [
                  _vm._v("Должности не найдены"),
                ])
              : _c(
                  "div",
                  { staticClass: "list" },
                  _vm._l(_vm.filteredList, function (position) {
                    return _c(
                      "div",
                      { key: position.code, staticClass: "list-item" },
                      [
                        _c("c-switcher", {
                          attrs: {
                            type: "checkbox",
                            label: position.name,
                            value: _vm.visible.includes(position.code),
                          },
                          on: {
                            input: function ($event) {
                              return _vm.togglePosition(position, $event)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
          ]),
          _c(
            "div",
            { staticClass: "m-shifts-buttons" },
            [
              _c("c-button", {
                staticClass: "reset",
                attrs: { size: "large", label: "Сбросить" },
                on: { click: _vm.close },
              }),
              _c("c-button", {
                staticClass: "apply",
                attrs: { size: "large", label: "Применить", color: "blue" },
                on: { click: _vm.apply },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }